import React, {Component} from 'react';
import Select from 'components/common/select/Select.component';
import { Button, ButtonType } from 'components/common/Button.component';
import { FormField } from 'components/common/FormField.component';
import * as reduxSelectors from "../../store/application.reducers";
import {connect} from "react-redux";
import {getOrgChartTreeNodes} from "../../organisationChart/organisationChart.action";
import { MODAL_ACTIONS } from "utils/constants";
import { useModalContext } from "components/modals/ModalContext";

export class SimulatorOrganisationChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: ''
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.onConfirmModal = this.onConfirmModal.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onSelectInputChange = this.onSelectInputChange.bind(this);

        this.fieldRef = null;
    }


    componentDidMount() {
        this.props.getOrgChartTreeNodes(new Date(),null,this.props.companyId);
    }

    showModal() {
        this.props.toggleModal?.(MODAL_ACTIONS.ORGANISATION_CHART, {
            handleAction: this.onConfirmModal,
            closeCallback: this.hideModal,
        });
    }

    hideModal() {
        this.props.toggleModal?.(null);
    }

    onConfirmModal(node) {
        this.props.toggleModal?.(null);

        if (!node) {
            return;
        }

        this.props.onChange({
            value: node.item.organizationUnitId,
            label: `${node.item.organizationUnitCode} - ${node.item.name}`
        });
    }

    onSelectChange(option) {
        this.props.onChange(option || null);
    }

    onSelectInputChange(value) {
        this.setState({
            search: value
        });
    }

    render() {
        const options = this.state.search !== '' ? this.props.selectEntries : [];
        const selected = this.props.orgChartId;
        return (
            <div className="form-group organization-chart-input">
                <FormField
                    id="simulator-organisation-unit"
                    label={this.props.translate("workflowDetails.simulator.organisationUnit")}
                >
                    <div className="form-group d-flex align-items-center gap-2">
                        <div className="flex-grow-1">
                            <Select
                                options={options}
                                ref={(field) => { this.props.onRefInit(field) }}
                                value={selected}
                                inputValue={this.state.search}
                                isClearable={true}
                                isSearchable={true}
                                onChange={this.onSelectChange}
                                onInputChange={this.onSelectInputChange}
                                name="department"
                                translate={this.props.translate}
                            />
                        </div>
                        <Button
                            type={ButtonType.SECONDARY}
                            text={this.props.translate("workflowDetails.simulator.select")}
                            onClick={this.showModal}
                            extraClassName="open-modal-button"
                            ariaLabel={this.props.translate("workflowDetails.simulator.openOrganisationChart")}
                            tooltip={{
                                id: "simulator-org-chart-tooltip",
                                content: () => this.props.translate("workflowDetails.simulator.openOrganisationChart")
                            }}
                        />
                    </div>
                </FormField>
            </div>
        );
    }
}


const mapStateToProps = function (store) {
    const orgChartTree = reduxSelectors.getOrgChartTree(store);

    return {
        orgChartTree,
        companyId: reduxSelectors.getUsersCurrentContextId(store),
        selectEntries: orgChartTree && orgChartTree.rows
            .map((node) => ({
                label: `${node.item.organizationUnitCode} - ${node.item.name}`,
                value: node.item.organizationUnitId
            })),
    };
};

const Connected = connect(mapStateToProps, {
    getOrgChartTreeNodes,
})(SimulatorOrganisationChart);

const SimulatorOrganisationChartWithModal = (props) => {
    const modalContext = useModalContext();
    const { toggleModal } = modalContext || {};
    return <Connected {...props} toggleModal={toggleModal} />;
};

export default SimulatorOrganisationChartWithModal;
